import { useTranslation } from '@framework/i18n';
import { Alert, Button } from 'antd';
import clx from 'classnames';
import React, { useState } from 'react';
import styled from 'styled-components';
import { RichTextAdvancedRender } from '../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender';
import { IWidgetComponentProps } from '../../../IWidgetType';
import { useWidgetVisibility } from '../../../hooks/useWidgetVisibility';
import { ParagraphSizeText } from '../../common/style/ParagraphSizeText';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps';
import { IInfoWidget } from './IInfoWidget';

export interface IInfoWidgetComponentProps
  extends IWidgetComponentProps<IInfoWidget> {}

const StyledAlert = styled(Alert)`
  margin-bottom: 24px;

  &.ant-alert-info.alert--simple {
    background-color: ${({ theme }) => theme.colorBgLayout};
    border-color: ${({ theme }) => theme.colorBorder};

    .anticon {
      color: ${({ theme }) => theme.colorBorder};
    }
  }
`;

export function InfoWidgetComponent(props: IInfoWidgetComponentProps) {
  const { widget } = props;
  const options = getWidgetProps(props);
  const { t } = useTranslation();
  const visible = useWidgetVisibility(props.widget, options);

  // Solo se è contraibile, di default è chiuso. Altrimenti è sempre aperto.
  const isCollapsible = !!props.widget.layout?.collapsible;
  const [isCollapsed, setIsCollapsed] = useState(isCollapsible);

  if (!visible) return null;

  return (
    <StyledAlert
      role="note"
      showIcon={widget.layout?.showIcon}
      className={clx({
        'alert--simple': widget.layout?.type === 'default',
      })}
      type={
        widget.layout?.type === 'default'
          ? undefined
          : widget.layout?.type ?? 'info'
      }
      description={
        <ParagraphSizeText>
          <RichTextAdvancedRender
            text={
              isCollapsed
                ? widget.layout?.collapsibleBody
                : widget.body ??
                  (options.preview
                    ? [
                        {
                          type: 'text',
                          text: t(
                            'info-widget.new-info-message',
                            'Nuovo messaggio informativo',
                          ),
                        },
                      ]
                    : [])
            }
            hasCustomFont
          />
        </ParagraphSizeText>
      }
      action={
        isCollapsible ? (
          <Button
            type="default"
            onClick={() => setIsCollapsed(!isCollapsed)}
            style={{ marginLeft: 8 }}
          >
            {isCollapsed
              ? widget.layout?.collapsibleExpandText ??
                t('info-widget.expand', 'Espandi')
              : widget.layout?.collapsibleCollapseText ??
                t('info-widget.collapse', 'Contrai')}
          </Button>
        ) : undefined
      }
    />
  );
}
